var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-table', {
    staticClass: "table-outline mb-0",
    attrs: {
      "hover": "hover",
      "responsive": "responsive",
      "outline": "outline",
      "head-variant": "default",
      "items": _vm.data,
      "fields": _vm.label,
      "small": _vm.small,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc
    },
    on: {
      "row-clicked": _vm.ping,
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "avatar",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [(item.value.tooltip) ? _c('img', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.userIdString(item.value.tooltip)),
            expression: "userIdString(item.value.tooltip)",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url || "static/img/avatars/0.png",
            "alt": ""
          }
        }) : _vm._e(), (item.value.status) ? _c('span', {
          staticClass: "avatar-status",
          class: {
            'bg-success': item.value.status == 'success', 'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == ''
          }
        }) : _vm._e()])]
      }
    }, {
      key: "avatarPlain",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [_c('img', {
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url,
            "alt": ""
          }
        })])]
      }
    }, {
      key: "user",
      fn: function(item) {
        return [_c('div', [_vm._v(_vm._s(item.value.name) + " "), (item.value.gender) ? _c('span', [(item.value.gender == "male") ? _c('i', {
          staticClass: "fa fa-mars text-primary"
        }) : _c('i', {
          staticClass: "fa fa-venus text-danger"
        })]) : _vm._e()]), _c('div', {
          staticClass: "small text-muted"
        }, [_c('span', [(item.value.new) ? [_vm._v("New")] : [_vm._v("Recurring")]], 2), _vm._v(" | Registered: "), (typeof item.value.registered == "number") ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(item.value.registered, "from", "now")))]) : _c('span', [_vm._v(_vm._s(item.value.registered))])])]
      }
    }, {
      key: "name",
      fn: function(item) {
        return [_c('span', {
          staticClass: "text-capitalize"
        }, [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "company",
      fn: function(item) {
        return [_c('div', [_vm._v(_vm._s(item.value.name) + " ")]), _c('div', {
          staticClass: "small text-muted"
        }, [_vm._v(_vm._s(item.value.Id))])]
      }
    }, {
      key: "country",
      fn: function(item) {
        return [_c('img', {
          staticStyle: {
            "height": "24px"
          },
          attrs: {
            "src": item.value.flag,
            "alt": item.value.name
          }
        })]
      }
    }, {
      key: "usage",
      fn: function(item) {
        return [_c('div', {
          staticClass: "clearfix"
        }, [_c('div', {
          staticClass: "float-left"
        }, [_c('strong', [_vm._v(_vm._s(item.value.value) + "%")])]), _c('div', {
          staticClass: "float-right"
        }, [_c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(item.value.period))])])]), _c('b-progress', {
          staticClass: "progress-xs",
          attrs: {
            "variant": _vm.variant(item.value.value)
          },
          model: {
            value: (item.value.value),
            callback: function($$v) {
              item.value.value = $$v
            },
            expression: "item.value.value"
          }
        })]
      }
    }, {
      key: "payment",
      fn: function(item) {
        return [_c('i', {
          class: item.value.icon,
          staticStyle: {
            "font-size": "24px"
          }
        })]
      }
    }, {
      key: "activity",
      fn: function(item) {
        return [_c('div', {
          staticClass: "small text-muted"
        }, [_vm._v("Last login")]), _c('strong', [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "actions",
      fn: function(item) {
        return [_c('b-btn-group', [_c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Reply"),
            expression: "\"Reply\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "pill-left",
          attrs: {
            "type": "button",
            "variant": "outline-primary",
            "id": "send" + item.value.id
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-paper-plane-o"
        })]), _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("History"),
            expression: "\"History\"",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "type": "button",
            "variant": "outline-secondary",
            "to": _vm.chatLink(item.value.id),
            "router-tag": "button"
          }
        }, [_c('i', {
          staticClass: "fa fa-history"
        })]), (!item.value.paused) ? _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Pause Chatbot"),
            expression: "\"Pause Chatbot\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "pill-right",
          attrs: {
            "type": "button",
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.pause(item.value.id, item.value.msgID, item.value.timestamp)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })]) : _vm._e(), (item.value.paused) ? _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Unpause Chatbot"),
            expression: "\"Unpause Chatbot\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "pill-right",
          attrs: {
            "type": "button",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.unpause(item.value.id, item.value.msgID, item.value.timestamp)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })]) : _vm._e()], 1), _c('b-popover', {
          ref: "popover",
          attrs: {
            "target": "send" + item.value.id,
            "placement": "left",
            "triggers": "click"
          }
        }, [_c('b-form', {
          attrs: {
            "inline": "inline"
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
              _vm.sendMessage(item.value.id)
            },
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('b-form-input', {
          staticClass: "pill-left",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.messageModel[item.value.id]),
            callback: function($$v) {
              _vm.$set(_vm.messageModel, item.value.id, $$v)
            },
            expression: "messageModel[item.value.id]"
          }
        }), _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.sending ? "Sending Message" : "Send Message"),
            expression: "sending ? \"Sending Message\" : \"Send Message\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn pill-right",
          attrs: {
            "type": "button",
            "variant": "outline-primary",
            "disabled": !_vm.messageModel[item.value.id]
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.sendMessage(item.value.id)
            }
          }
        }, [(_vm.sending) ? _c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }) : _c('i', {
          staticClass: "icon-paper-plane"
        })])], 1)], 1)]
      }
    }, {
      key: "quicksend",
      fn: function(item) {
        return [_c('b-form', {
          attrs: {
            "inline": "inline"
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
              _vm.sendMessage(item.value.id, true)
            },
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('b-input-group', {
          staticClass: "ml-auto"
        }, [_c('b-form-input', {
          model: {
            value: (_vm.messageModel[item.value.id]),
            callback: function($$v) {
              _vm.$set(_vm.messageModel, item.value.id, $$v)
            },
            expression: "messageModel[item.value.id]"
          }
        }), _c('b-input-group-button', {
          slot: "right"
        }, [(!item.value.paused) ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Pause Chatbot"),
            expression: "\"Pause Chatbot\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn",
          attrs: {
            "type": "button",
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              _vm.pause(item.value.id, item.value.msgID, item.value.timestamp)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pause"
        })]) : _vm._e(), (item.value.paused) ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Unpause Chatbot"),
            expression: "\"Unpause Chatbot\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn",
          attrs: {
            "type": "button",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.unpauseResolve(item.value.id, item.value.msgID, item.value.timestamp, true)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-play"
        })]) : _vm._e(), _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Spam"),
            expression: "\"Spam\"",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "type": "button",
            "variant": "outline-danger"
          },
          on: {
            "click": function($event) {
              _vm.spam(item.value.id, item.value.msgID, item.value.timestamp, true)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-shield"
        })]), _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.sending ? "Sending Message" : "Send Message"),
            expression: "sending ? \"Sending Message\" : \"Send Message\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn text-white",
          attrs: {
            "type": "submit",
            "variant": "secondary",
            "disabled": !_vm.messageModel[item.value.id]
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.sendMessage(item.value.id, true)
            }
          }
        }, [(_vm.sending) ? _c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }) : _c('i', {
          staticClass: "icon-paper-plane"
        })])], 1)], 1)], 1)]
      }
    }, {
      key: "timestamp",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("moment")(item.value, "from", "now")))]
      }
    }, {
      key: "momentDate",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("moment")(item.value, "from", "now")))]
      }
    }, {
      key: "numTimestamp",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("moment")(item.value, "Do MMM 'YY, hh:mmA")))]
      }
    }, {
      key: "timezone",
      fn: function(item) {
        return [_vm._v("+" + _vm._s(item.value))]
      }
    }, {
      key: "message",
      fn: function(item) {
        return [_c('div', [_vm._v(_vm._s(item.value))])]
      }
    }, {
      key: "messagePair",
      fn: function(item) {
        return [_c('div', {
          staticClass: "text-secondary"
        }, [_vm._v(_vm._s(item.value.messagePrev))]), _c('div', [_vm._v(_vm._s(item.value.message))])]
      }
    }, {
      key: "upperCase",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("upperCase")(item.value)))]
      }
    }, {
      key: "nric",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("nric")(item.value)))]
      }
    }, {
      key: "messageId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "fbId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "phoneId",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "topic",
      fn: function(item) {
        return [_vm._v(_vm._s(_vm._f("cleanTime")(item.value)))]
      }
    }, {
      key: "intent",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "users",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "interactions",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "exits",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value)), _c('small', [_vm._v("%")])]
      }
    }, {
      key: "respondTime",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value)), _c('small', [_vm._v("s")])]
      }
    }, {
      key: "agent",
      fn: function(item) {
        return [_c('div', {
          staticClass: "avatar"
        }, [_c('img', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: (_vm.userIdString(item.value.tooltip)),
            expression: "userIdString(item.value.tooltip)",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "img-avatar",
          attrs: {
            "src": item.value.url,
            "alt": ""
          }
        })])]
      }
    }, {
      key: "campaign",
      fn: function(item) {
        return [(item.value.campaignTitle) ? _c('div', [_vm._v(_vm._s(item.value.campaignTitle))]) : _c('div', [_vm._v("Untitled Campaign")]), _c('div', {
          staticClass: "small text-muted"
        }, [_vm._v(_vm._s(item.value.campaign))])]
      }
    }, {
      key: "startDate",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "endDate",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "audience",
      fn: function(item) {
        return [_vm._v(_vm._s(item.value))]
      }
    }, {
      key: "sent",
      fn: function(item) {
        return [(item.value) ? _c('i', {
          staticClass: "fa fa-check text-success"
        }) : _c('i', {
          staticClass: "fa fa-spinner"
        })]
      }
    }, {
      key: "statusString",
      fn: function(item) {
        return [(item.value.mapUrl != "null") ? _c('b-btn', {
          staticClass: "mr-1 text-white",
          attrs: {
            "type": "button",
            "variant": "secondary",
            "href": item.value.mapUrl,
            "target": "_blank",
            "disabled": !item.value.mapUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-map-marker"
        })]) : _vm._e(), (item.value.formUrl != "null") ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "primary",
            "href": item.value.formUrl,
            "target": "_blank",
            "disabled": !item.value.formUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-file-o"
        })]) : _vm._e(), (item.value.imageUrl != "null") ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "primary",
            "href": item.value.imageUrl,
            "target": "_blank",
            "disabled": !item.value.imageUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-file-image-o"
        })]) : _vm._e(), (item.value.carUrl != "null") ? _c('b-btn', {
          staticClass: "mr-1 text-white",
          attrs: {
            "type": "button",
            "variant": "secondary",
            "href": item.value.carUrl,
            "target": "_blank",
            "disabled": !item.value.carUrl
          }
        }, [_c('i', {
          staticClass: "fa fa-car"
        })]) : _vm._e(), (item.value.btn1 == "Followed Up" && !item.value.resolved) ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.resolved(item.value.id, item.value.crm, item.value.resolved)
            }
          }
        }, [_vm._v("Mark as Done")]) : (item.value.btn1 == "Followed Up" && item.value.resolved && item.value.userAccessLevel == "agent") ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "outline-success",
            "disabled": "disabled"
          },
          on: {
            "click": function($event) {
              _vm.resolved(item.value.id, item.value.crm, item.value.resolved)
            }
          }
        }, [_vm._v("Done")]) : (item.value.btn1 == "Followed Up" && item.value.resolved) ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              _vm.resolved(item.value.id, item.value.crm, item.value.resolved)
            }
          }
        }, [_vm._v("Mark as Undone")]) : (item.value.btn1) ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "success"
          }
        }, [_vm._v(_vm._s(item.value.btn1))]) : (item.value.btn1) ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "success"
          }
        }, [_vm._v("Qualify")]) : _vm._e(), (item.value.remark == null || item.value.remark == "") ? _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "success",
            "id": "remark" + item.value.id
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("Make Remark")]) : _c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "outline-success",
            "id": "viewRemark" + item.value.id
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("View Remark")]), (item.value.remark == null || item.value.remark == "") ? _c('b-popover', {
          ref: "popover",
          attrs: {
            "target": "remark" + item.value.id,
            "placement": "left",
            "triggers": "click"
          }
        }, [_c('b-form', {
          attrs: {
            "inline": "inline"
          },
          on: {
            "submit": _vm.sendRemark
          }
        }, [_c('b-form-input', {
          staticClass: "pill-left",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.messageModel[item.value.id]),
            callback: function($$v) {
              _vm.$set(_vm.messageModel, item.value.id, $$v)
            },
            expression: "messageModel[item.value.id]"
          }
        }), _c('b-btn', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (_vm.sending ? "Sending Remark" : "Send Remark"),
            expression: "sending ? \"Sending Remark\" : \"Send Remark\"",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn pill-right",
          attrs: {
            "type": "button",
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.sendRemark(item.value.id, item.value.crm, _vm.messageModel[item.value.id])
            }
          }
        }, [(_vm.sending) ? _c('i', {
          staticClass: "fa fa-refresh fa-spin"
        }) : _c('i', {
          staticClass: "fa fa-chevron-right"
        })])], 1)], 1) : _c('b-popover', {
          ref: "popover",
          attrs: {
            "target": "viewRemark" + item.value.id,
            "placement": "left",
            "triggers": "click"
          }
        }, [_c('b-form-input', {
          attrs: {
            "type": "text",
            "readonly": "readonly"
          },
          model: {
            value: (item.value.remark),
            callback: function($$v) {
              item.value.remark = $$v
            },
            expression: "item.value.remark"
          }
        })], 1)]
      }
    }, {
      key: "approval",
      fn: function(item) {
        return [(item.value == "approved") ? _c('i', {
          staticClass: "fa fa-check text-success"
        }) : (item.value == "pending") ? _c('i', {
          staticClass: "fa fa-spinner"
        }) : _c('i', {
          staticClass: "fa fa-times text-danger"
        })]
      }
    }, {
      key: "platform",
      fn: function(item) {
        return [_c('b-row', [_c('b-col', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Email"),
            expression: "\"Email\"",
            modifiers: {
              "hover": true
            }
          }]
        }, [_c('i', {
          staticClass: "fa fa-envelope-o",
          class: {
            "text-success": item.value.email
          }
        })]), _c('b-col', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("SMS"),
            expression: "\"SMS\"",
            modifiers: {
              "hover": true
            }
          }]
        }, [_c('i', {
          staticClass: "fa fa-mobile",
          class: {
            "text-success": item.value.sms
          }
        })]), _c('b-col', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: ("Facebook Messenger"),
            expression: "\"Facebook Messenger\"",
            modifiers: {
              "hover": true
            }
          }]
        }, [_c('i', {
          staticClass: "fa fa-facebook",
          class: {
            "text-success": item.value.messenger
          }
        })])], 1)]
      }
    }, {
      key: "broadcastActions",
      fn: function(item) {
        return [_c('router-link', {
          attrs: {
            "to": _vm.broadcastLink(item.value)
          }
        }, [_c('b-btn', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "variant": "outline-secondary"
          }
        }, [_c('i', {
          staticClass: "fa fa-chevron-right"
        })])], 1)]
      }
    }, {
      key: "loanAmount",
      fn: function(item) {
        return [_c('div', [_vm._v("RM " + _vm._s(item.value))])]
      }
    }, {
      key: "turnOverAmount",
      fn: function(item) {
        return [_c('div', [_vm._v("RM " + _vm._s(item.value))])]
      }
    }, {
      key: "influence",
      fn: function(item) {
        return [_c('i', {
          staticClass: "fa",
          class: ["fa-users", "text-" + _vm.influence(item.value)]
        }), _vm._v(" " + _vm._s(item.value))]
      }
    }, {
      key: "manualRate",
      fn: function(item) {
        return [_c('input', {
          staticClass: "checkbox",
          attrs: {
            "type": "checkbox"
          },
          on: {
            "click": function($event) {
              _vm.checkboxToggle(item.value.key)
            }
          }
        })]
      }
    }, {
      key: "reason",
      fn: function(item) {
        return [_c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: (item.value),
            expression: "item.value",
            modifiers: {
              "hover": true
            }
          }]
        }, [_vm._v(_vm._s(item.value))])]
      }
    }])
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eadc7b02","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = 1388
// module chunks = 1